import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <img
                src="/images/gaminggrid-logo.png"
                alt="GamingGrid Agency"
                className="footer-logo-image"
              />
            </div>
            <p className="footer-tagline">
              Leveling up gaming brands through strategic marketing and community building.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Connect</h4>
              <a
                href="https://x.com/GamingGridAgency"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on X (Twitter)"
                className="social-link"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
                Twitter/X
              </a>
              <a href="mailto:hello@gaminggrid.agency" aria-label="Email us">
                Email
              </a>
            </div>

            <div className="footer-column">
              <h4>Company</h4>
              <a href="#services">Services</a>
              <a href="#case-studies">Work</a>
              <a href="#team">Team</a>
              <a href="#contact">Contact</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            © {currentYear} GamingGrid Agency. All rights reserved.
          </div>
          <div className="footer-legal">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;